import { Chip, Stack } from '@mui/material';

interface SuggestedCategoriesListProps {
  categories?: string[];
  onSelectCategory?: (category?: string) => void;
}

export default function SuggestedCategoriesList({
  categories = [],
  onSelectCategory = () => {},
}: Readonly<SuggestedCategoriesListProps>) {
  return (
    <Stack
      direction='row'
      sx={{
        gap: 1,
        flexWrap: 'wrap',
      }}
    >
      {categories.map((category) => (
        <Chip
          key={category}
          label={category}
          onClick={() => onSelectCategory(category)}
          size='small'
          sx={{
            fontSize: '0.875em',
            lineHeight: '150%',
            height: 'inherit',
            paddingY: 0.375,
            paddingX: 0.25,
          }}
        />
      ))}
    </Stack>
  );
}
